// extracted by mini-css-extract-plugin
export default {"wrapper":"A_SmallInput_wrapper__tUKtl","background-gray":"A_SmallInput_background-gray__h2Ywa","background-white":"A_SmallInput_background-white__gtZin"};